import React, { memo } from "react";
import { withRedux, WithReduxHocPropsType } from "@al/next/al-ex";

import HomeSkeleton from "./index";

interface Props extends WithReduxHocPropsType {
  loading: boolean;
}

const ClientHomeSkeleton: React.FC<Props> = (props) => {
  if (!props.loading) return null;
  return <HomeSkeleton />;
};

export default withRedux((state) => ({ loading: !state.asyncReducers?.asyncGetProductSkuInfos?.isReady }))(
  memo(ClientHomeSkeleton)
);
